<template>
	<div class="banner-container" v-if="bannerlist.length > 0">
		<div class="swiper-container gallery_banner">
			<div class="swiper-wrapper">
				<div class="swiper-slide" v-for="(item,index) in bannerlist" :key="`bannerlist${index}`">
					<img :src="item.pic" alt="" />
				</div>
			</div>
		</div>
		<div class="swiper-pagination"></div>
	</div>
</template>
<script>
	import Swiper from "swiper";
	import {index_banner_api} from "@/api/index"
	export default {
		data() {
			return {
				swiperOptionThumbs: {},
				bannerlist:[]
			};
		},
		methods:{
			galleryTopLunbo() {
				new Swiper(".gallery_banner", {
					spaceBetween: 0,
					loop: true,
					loopedSlides: 5,
					autoplay: {
					  delay: 4500,
					  disableOnInteraction: false,
					},
					pagination: {
					  el: ".swiper-pagination",
					  clickable: true
					},
				});
			},
			async getBanner() {
			  const res = await index_banner_api();
			  if (res && res.data.code == 1) {
				  this.bannerlist = res.data.data
				  this.$nextTick(function() {
				  	this.galleryTopLunbo();
				  });
			  }
			},
		},
		mounted() {
			this.getBanner();
		}
	}
</script>
<style scoped>
	.banner-container{
		position: relative;
	}
	.swiper-pagination{
		width: 100%;
		bottom: 10px;
	}
</style>

